type ReviewStarsProps = {
  rating: 1 | 2 | 3 | 4 | 5;
};

export function ReviewStars({ rating }: ReviewStarsProps) {
  return (
    <img
      className="pa-vb-review-stars"
      src="/media/misc/five_stars_gold_linear.png"
      alt={`${rating} out of 5 stars`}
    />
  );
}
